const CLASS_BY_TYPE = {
  success: 'alert-success',
  error: 'alert-error',
  info: 'alert-info'
}

export const showToast = (message, type = 'info') => {
  const containerId = 'acl-toast-container'
  let container = document.getElementById(containerId)

  if (!container) {
    container = document.createElement('div')
    container.id = containerId
    container.className = 'fixed top-4 right-4 z-[120] space-y-2'
    document.body.appendChild(container)
  }

  const toast = document.createElement('div')
  toast.className = `alert shadow-md ${CLASS_BY_TYPE[type] || CLASS_BY_TYPE.info}`
  toast.textContent = message

  container.appendChild(toast)

  window.setTimeout(() => {
    toast.remove()
    if (!container.childElementCount) {
      container.remove()
    }
  }, 2600)
}

